import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { GuessBosses } from "./features/GuessBosses";
import { Layout } from "./components/Layout";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
const theme = createTheme({
  palette: {
    primary: {
      main: "#3c3734",
    },
  },
});
function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<GuessBosses />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
